import React from "react";
import { FeaturesWithCTAs, IFeaturesWithCTAsProps } from "../../../components/panels/FeaturesWithCTAs";
import {
  IProps as IImageWithTitleProps,
} from "../../../components/ImageWithTitleAndText";

export type GetFeaturesWithCTAsProps =
  IFeaturesWithCTAsProps & { id: string, imageWithTitleAndText: IImageWithTitleProps[] };

export const getFeaturesWithCTAs = ({
  id,
  imageWithTitleAndText,
  ctas,
  backgroundColour,
  title,
  headingType,
  headerAnchor,
}: GetFeaturesWithCTAsProps) => (
  <FeaturesWithCTAs
    title={title}
    key={id}
    imagesWithTitleAndText={imageWithTitleAndText}
    ctas={ctas}
    backgroundColour={backgroundColour}
    headingType={headingType}
    headerAnchor={headerAnchor}
  />
);
